import React, { useState } from "react";
import {
  Backdrop,
  Modal,
  Header,
  Title,
  Body,
  Field,
  Label,
  ReadOnlyBox,
  Input,
  BoolRow,
  BoolItem,
  Footer,
  Button,
} from "./styles";
import { kvmAPI } from "api";

interface Props {
  instanceName: string;
  onClose?: () => void;
  onMigrate?: (data: {
    instanceName: string;
    hostName: string;
    start: boolean;
  }) => void;
}

const MigrateModal: React.FC<Props> = ({ instanceName, onClose }) => {
  const [hostName, setHostName] = useState("");
  const [start, setStart] = useState(true);

  const handleConfirm = () => {
    kvmAPI.migrate(instanceName, hostName, start);
    onClose?.();
  };

  const disabled = !hostName.trim();

  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>Instance Migrate</Title>
        </Header>

        <Body>
          <Field>
            <Label>Instance Name</Label>
            <ReadOnlyBox>{instanceName}</ReadOnlyBox>
          </Field>

          <Field>
            <Label>Host Name</Label>
            <Input
              type="text"
              value={hostName}
              onChange={(e) => setHostName(e.target.value)}
              placeholder="target-host-01"
            />
          </Field>

          <Field>
            <Label>Options</Label>
            <BoolRow>
              <BoolItem>
                <input
                  type="checkbox"
                  checked={start}
                  onChange={(e) => setStart(e.target.checked)}
                />
                Start
              </BoolItem>
            </BoolRow>
          </Field>
        </Body>

        <Footer>
          <Button variant="ghost" onClick={onClose}>
            취소
          </Button>
          <Button variant="primary" onClick={handleConfirm} disabled={disabled}>
            마이그레이션
          </Button>
        </Footer>
      </Modal>
    </Backdrop>
  );
};

export default MigrateModal;
